import React from 'react';

const backdropStyle = {
  width: "100%",
  height: "100%",
  position: "fixed",
  zIndex: "100",
  // top: "15vh",
  left: "0",
  top: "10%",
  backgroundColor: "rgba(0, 0, 0, 0.02)"
}

const HeaderBackdrop = props => (
  props.showModal ? <div style={backdropStyle} onClick={props.clicked}></div> : null
);

export default HeaderBackdrop;